import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '@/components/landing/LandingPage.vue'
import MainConversationComponent from '@/components/conversations/MainConversationComponent.vue'
import UserLogin from '@/components/authentication/Login.vue'
import UserRegister from '@/components/authentication/Register.vue'
import PricingComponent from '@/components/pricing/PricingComponent.vue'
import ContactPage from '@/components/contact/ContactPage.vue'
import SettingsComponent from '@/components/settings/SettingsComponent.vue'
import AboutPage from '@/components/about/AboutPage.vue'
import DashboardComponent from './components/dashboard/DashboardComponent.vue'
import { useUserStore } from '@/stores/users'
import TermsOfService from './components/layout/TermsOfService.vue'
import PrivacyPolicy from './components/layout/PrivacyPolicy.vue'

const routes = [
  { path: '/', name: 'Landing', component: LandingPage },
  {
    path: '/conversation',
    name: 'Conversation',
    component: MainConversationComponent,
    meta: { requiresAuth: true }
  },
  { path: '/login', name: 'Login', component: UserLogin, meta: { requiresGuest: true } },
  { path: '/register', name: 'Register', component: UserRegister, meta: { requiresGuest: true } },
  { path: '/pricing', name: 'Pricing', component: PricingComponent },
  { path: '/contact', name: 'Contact', component: ContactPage },
  { path: '/settings', name: 'Settings', component: SettingsComponent, meta: { requiresAuth: true } },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/dashboard', name: 'Dashboard', component: DashboardComponent, meta: { requiresAuth: true } },
  { path: '/tos', name: 'TermsOfService', component: TermsOfService },
  { path: '/privacy', name: 'PrivacyPolicy', component: PrivacyPolicy }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Use beforeEach for stricter guard that runs before navigation confirmation
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()

  // --- Wait for initial auth state check ---
  if (!userStore.authIsReady && (to.meta.requiresAuth || to.meta.requiresGuest)) {
    console.log('Router Guard: Auth not ready, waiting...')
    // Wait until the authIsReady flag becomes true
    await new Promise(resolve => {
      const unsubscribe = userStore.$subscribe((mutation, state) => {
        if (state.authIsReady) {
          console.log('Router Guard: Auth is now ready.')
          unsubscribe() // Clean up the subscription
          resolve()
        }
      })
      // Edge case: If already ready when this check runs
      if (userStore.authIsReady) {
        console.log('Router Guard: Auth was already ready.')
        unsubscribe()
        resolve()
      }
    })
  }

  // --- Apply routing rules based on current auth state ---
  const requiresAuth = to.meta.requiresAuth
  const requiresGuest = to.meta.requiresGuest
  const isAuthenticated = userStore.isAuthenticated // Get current state

  console.log(`Router Guard: Navigating to ${to.path}. Auth: ${isAuthenticated}, RequiresAuth: ${requiresAuth}, RequiresGuest: ${requiresGuest}`)

  if (requiresAuth && !isAuthenticated) {
    console.log('Router Guard: Access denied (Auth Required). Redirecting to Login.')
    // Redirect to login, preserving intended destination
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (requiresGuest && isAuthenticated) {
    console.log('Router Guard: Access denied (Guest Required). Redirecting to Dashboard.')
    // Redirect logged-in users away from guest pages
    next({ name: 'Dashboard' }) // Or wherever they should go, e.g., '/'
  } else {
    // Allow navigation
    console.log('Router Guard: Access granted.')
    next()
  }
})

// REMOVE the router.beforeResolve guard if it exists, use beforeEach instead.

export default router
